import React from 'react'
import PropTypes from 'prop-types'
import { BqTag } from '@beeq/react'
import { Text } from '../../../constants/TextConstants'
import { StyledAppliedFiltersWrapper, StyledAppliedFiltersTags } from './styles'

export default function UsersAdvancedFiltersSelectedFilters({ values, onClose, orientation = 'vertical' }) {
  return (
    <StyledAppliedFiltersWrapper orientation={orientation}>
      <label className='caption'>{Text.UsersAdvancedFiltersAppliedFilters}</label>
      <StyledAppliedFiltersTags>
        {Object.entries(values).flatMap(([key, array]) => {
          if (!Array.isArray(array)) {
            return null
          }

          return array.map((item) => (
            <BqTag
              key={`${key}-${item}`}
              removable
              size="small"
              onBqClose={(event) => {
                event.stopImmediatePropagation()
                onClose(key, array.filter((value) => value !== item))
              }}
            >
              {item}
            </BqTag>))
        })}
      </StyledAppliedFiltersTags>
    </StyledAppliedFiltersWrapper>
  )
}

UsersAdvancedFiltersSelectedFilters.propTypes = {
  values: PropTypes.object,
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  onClose: PropTypes.func.isRequired
}
